import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SelectCustomEvent} from '@ionic/angular';
import {TipoDocEnum, TIPO_DOC} from '../../../_helpers/TipoDocEnum';

@Component({
  selector: 'app-select-tipo-doc',
  templateUrl: './select-tipo-doc.component.html',
  styleUrls: ['./select-tipo-doc.component.scss'],
})
export class SelectTipoDocComponent {
  @Input() tipoDoc: TipoDocEnum;
  @Output() tipoDocChange = new EventEmitter<TipoDocEnum>();
  tipoDocItem = TIPO_DOC;
  selectTipoDoc = (e: SelectCustomEvent) => this.tipoDocChange.emit(e.target.value);
}
